import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {choose} from 'lit/directives/choose.js';
import {connect} from 'pwa-helpers';
import {msg} from '@lit/localize';
import store from '../../../store';
import {LocationState} from '../../../slices/lightProfileSlice';

@customElement('visual-solar-luminar')
export class VisualSolarLuminar extends connect(store)(LitElement) {

	static styles = css`
		:host {
			display: flex;
			width: 100%;
			height: 100%;
			overflow: hidden;
		}
		.container {
			display: flex;
			flex-direction: row;
			gap: 20px;
			width: 100%;
		}
		.left {
			padding: 5% 0 10% 0;
			flex-basis: 25%;
			width: 25%;
		}
		.middle {
			flex-basis: 25%;
			width: 25%;
		}
		.right {
			display: flex;
			flex-direction: column;
			justify-content: center;
			flex-basis: 50%;
			width: 50%;
			gap: 50px;
		}
		.img {
			width: 100%;
		}

	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.state = state;
		this.lang = state.status.lang;
		this.region = state.status.region;
		this.translations = state.productData.translations;
		this.decisions = state.decisions.data;
		this.location = state.lightProfile.data.project.location;
		this.locationState = state.lightProfile.data.locationState;

	}
	render() {
		const s = this.state;
		return html`
			<div class="container">
				<div class="left">
					<svg-aeto-drawing></svg-aeto-drawing>
				</div>
				<div class="middle">
					<svg-aeto></svg-aeto>
				</div>
				<div class="right">
					<svg-aeto-lightdistribution></svg-aeto-lightdistribution>
					<svg-housingcolour></svg-housingcolour>
				</div>
			</div>
		`;
	}
}
